/**
 * Жёсткая отмена незавершённых запросов покинутых уровней (фидбек 2026-07-08):
 * новый запрос по тому же ключу («доска», «партнёры: в ожидании», …) отменяет
 * предыдущий (switchMap-семантика) — фронт реагирует только на запросы
 * просматриваемой матрицы, остальные физически стопаются.
 */
const controllers = new Map<string, AbortController>()

export const takeAbortSignal = (key: string): AbortSignal => {
  controllers.get(key)?.abort()
  const controller = new AbortController()
  controllers.set(key, controller)
  return controller.signal
}

export const isAbortError = (error: unknown): boolean =>
  (error as { name?: string } | null)?.name === 'AbortError'
